import * as React from "react";
import { Sources } from "../lib/models/Chat";
import { Alert, Tooltip } from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import InfoIcon from "@mui/icons-material/Info";

interface SourcesAccordionProps {
  sources: Sources;
}
const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `white`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandCircleDownOutlinedIcon
        transform={"rotate(-180)"}
        color={"primary"}
        sx={{ marginLeft: 0 }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "light" ? "rgba(0, 0, 0, 0)" : "rgba(0, 0, 0, 0)",
  flexDirection: "row-reverse",
  paddingLeft: 0,
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: 0,
  paddingTop: 0,
}));

export default function SourcesAccordion(props: SourcesAccordionProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Accordion
      elevation={0}
      expanded={expanded === "sources"}
      onChange={handleChange("sources")}
    >
      <AccordionSummary
        aria-controls="sources-content"
        id="sources-header"
        color={"primary"}
      >
        <Typography color={"#1976D2"}>
          Sources
          <Tooltip
            placement="right"
            title="Please note that the results are displayed from most to least semantically similar, which means they will appear from most to least relevant."
          >
            <InfoIcon sx={{ marginLeft: "2px" }} fontSize="inherit" />
          </Tooltip>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography component="div">
          {Object.entries(props.sources).map(([key, source], index) => (
            <Alert
              icon={false}
              key={index}
              sx={{ marginBottom: "1vh" }}
              severity="info"
            >
              [{index + 1}] -{" "}
              <a
                href={source.presigned_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {source.name.length < 100
                  ? source.name
                  : source.name.slice(0, 100) + "..."}
              </a>
            </Alert>
          ))}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
